import { SurfaceContext, type Surface } from './surface.context';

/** Declares the palette of the subtree so portaled kit content can match it. */
export function SurfaceProvider({ value, children }: { value: Surface; children: React.ReactNode }) {
  return <SurfaceContext.Provider value={value}>{children}</SurfaceContext.Provider>;
}
